import type { AreaUnits, Units } from '@turf/turf';
import { proxy } from 'valtio';
import type { UnitSystem } from '~/common/types';

export interface TLengthStore {
  unitType: Units;
  unitSystem: UnitSystem;
  length: number;
}

export interface TAreaStore {
  unitType: AreaUnits;
  unitSystem: UnitSystem;
  area: number;
  length: number;
}

export const lengthStore = proxy<TLengthStore>({
  unitType: 'feet',
  unitSystem: 'imperial',
  length: 0,
});

export const areaStore = proxy<TAreaStore>({
  unitType: 'acres',
  unitSystem: 'imperial',
  area: 0,
  length: 0,
});
